import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useLanguage } from '../contexts/LanguageContext';
import { SubscriptionCancelCards } from '../components/SubscriptionCancel';

// Public self-service cancellation, reached from the emails that link
// viralgpt.com/cancel. Same email-only lookup as /refund, and it lists BOTH
// billing relationships: the growth plan and the auto-refill subscription.
const CancelPortal = () => {
  const L = useLanguage();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleLookup = async (e) => {
    e.preventDefault();
    const email = e.target.email.value;
    setLoading(true);
    setError(null);
    try {
      const response = await fetch('https://api.viralgpt.com/cancel/lookup', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const body = await response.json();
      if (response.ok) {
        setData(body);
      } else {
        setError(body.error || L.refundPage.lookupFailed);
      }
    } catch {
      setError(L.refundPage.requestError);
    } finally {
      setLoading(false);
    }
  };

  const nothingToCancel = data && !data.active_subscription && !(data.refill_subscriptions || []).length;

  return (
    <>
      <Navbar />
      <div className="container py-5">
        <div className="text-center mb-5">
          <h1 className="text-instagram"><strong>{L.cancelPortal.title}</strong></h1>
          <p className="mt-3">{L.cancelPortal.intro}</p>
        </div>

        <div className="row justify-content-center">
          <div className="col-md-8">
            <div className="card shadow-sm">
              <div className="card-body">
                <h5 className="card-title mb-4">{L.cancelPortal.lookupTitle}</h5>

                <form onSubmit={handleLookup}>
                  <div className="mb-3">
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      placeholder={L.refundPage.emailPlaceholder}
                      required
                    />
                  </div>
                  <button type="submit" className="btn bg-instagram text-white w-100" disabled={loading}>
                    {loading ? L.common.loading : L.cancelPortal.findSubscriptions}
                  </button>
                </form>

                {error && <div className="alert alert-danger mt-3">{error}</div>}

                {nothingToCancel && (
                  <div className="alert alert-info mt-4 mb-0">
                    {L.cancelPortal.nothingToCancel}
                  </div>
                )}

                <SubscriptionCancelCards data={data} setData={setData} />

                <div className="mt-4 text-muted small">
                  <p className="mb-1">
                    <i className="fa-solid fa-redo me-1"></i>
                    {L.cancelPortal.refillHint} <a href="/refill" className="link-blue">{L.cancelPortal.refillLink}</a>
                  </p>
                  <p className="mb-1">
                    <i className="fa-solid fa-rotate-left me-1"></i>
                    {L.cancelPortal.refundHint} <a href="/refund" className="link-blue">{L.cancelPortal.refundLink}</a>
                  </p>
                  <p className="mb-0">{L.refundPage.immediateAssistance}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default CancelPortal;
